import React, { Component } from 'react';

import { Checkbox } from 'components/CheckboxGroup';
import { StepWrapper } from '../styles';
import { StepTitle, ButtonMain, StepFooter, CheckboxGroup } from './styles';

export default class ConfigureHarmonisationStep extends Component {
	onChange = e => {
		const { onChange, data: prevData } = this.props;
		const { value: key, checked } = e.target;
		const data = { ...prevData };

		if (!checked) {
			delete data[key];
		} else {
			data[key] = true;
		}

		onChange({ data });
	};

	render() {
		const { onSubmit, data } = this.props;

		return (
			<React.Fragment>
				<StepWrapper>
					<StepTitle>
						Please select options below to influence the harmonisation of the
						Vendor name:
					</StepTitle>
					<HarmonisationOptions onChange={this.onChange} data={data} />
					<StepFooter>
						<ButtonMain onClick={onSubmit}>Continue</ButtonMain>
					</StepFooter>
				</StepWrapper>
			</React.Fragment>
		);
	}
}

export const HarmonisationOptions = ({ onChange, data }) => (
	<CheckboxGroup>
		<Checkbox checked disabled value="">
			Match to known variants
		</Checkbox>
		<Checkbox checked disabled value="">
			Remove extra spaces from the start / middle / end of the Vendor name
		</Checkbox>
		<Checkbox value="titleCase" checked={data.titleCase} onClick={onChange}>
			Convert all Vendor names to Title Case
		</Checkbox>
		<Checkbox
			value="removeEntityType"
			checked={data.removeEntityType}
			onClick={onChange}
		>
			Remove Legal Entity Type (e.g. Microsoft Ltd, becomes Microsoft’)
		</Checkbox>
	</CheckboxGroup>
);
